export function alertNotImplemented(message = "Not yet implemented") {
  alert(message);
}
